// import React from "react";
import { FiSend } from "react-icons/fi";
import React, { useState, useEffect } from "react";
import { getSellerRevenueSummary } from "../../../../api/order/orderApi";
import { Container, Row, Col, Card, CardBody, Table } from "reactstrap";
import { getOrderSummaryByBoatOwner } from "../../../../api/order/orderApi";
import { getMontlyRevenue } from "../../../../api/order/orderApi";
import { getOrdersByProccesingPlantId } from '../../../../api/order/orderApi';
import { getIdGivenUserId } from '../../../../api/processing plant/plantApi';
import { AuthContext } from '../../../ExtraPages/AuthProvider';
import axios from 'axios';
import {
  faShoppingCart,
  faRefresh,
  faRocket,
  faCreditCard,
  faSpaghettiMonsterFlying,
  faPiggyBank,
  faCodeCompare,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Line, Bar, Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
  ArcElement,
} from 'chart.js';
import DataTable from 'react-data-table-component';
import manChecking from '../../../../assets/images/man-checking.png';
import { motion } from 'framer-motion';
// Register the necessary Chart.js components
ChartJS.register(
  LineElement,
  BarElement,
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const NeumorphismButton = () => {
  const buttonStyle = {
    padding: '6px 16px',
    border: 'none',
    borderRadius: '50px',
    backgroundColor: '#E6F0FA', // Light blue
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: '#003366', // Dark blue
    transition: 'all 0.3s ease',
  };

  const hoverStyle = {
    backgroundColor: '#003366', // Dark blue
    color: '#E6F0FA', // Light blue for hover effect
  };

  const [isHovered, setHovered] = React.useState(false);

  return (
    <button
      style={isHovered ? { ...buttonStyle, ...hoverStyle } : buttonStyle}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <FiSend />
      <span>Track</span>
    </button>
  );
};

const Overview = () => {
  const [isHovered, setHovered] = useState(false);
  // Remove revenue-related state
  // Dashboard will only show order-related stats

  const [orders, setOrders] = useState([]);
  const [plantId, setPlantId] = useState(null);
  const { user } = React.useContext(AuthContext);
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Monthly Revenue Line Chart',
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  // Define columns
  const columns = [
    { name: 'Fish Type', selector: (row) => row.Product_Name, sortable: true },
    { name: 'Quantity', selector: (row) => row.quantity, sortable: true },
    { name: 'Vessel Name', selector: (row) => row.boat_number, sortable: true },
    { name: 'Harbour', selector: (row) => row.Harbour, sortable: true },
    { name: 'Order Date', selector: (row) => row.Order_Date, sortable: true },

    // Status column
    {
      name: 'Status',
      cell: (row) => {
        if (row.Processing_Plant_status === 'false') {
          return <span className="status-button-danger">Rejected</span>;
        } else if (row.Processing_Plant_status === 'true') {
          return <span className="status-button-success">Accepted</span>;
        } else {
          return <span className="status-button-warning">Pending</span>;
        }
      },
      sortable: true,
    },
  ];
  // Fetch plantId based on user.uid
  React.useEffect(() => {
    const fetchPlantId = async () => {
      try {
        if (user?.uid) {
          const response = await getIdGivenUserId(user.uid);
          setPlantId(response.data);
        }
      } catch (error) {
        console.error('Error fetching plant ID:', error);
      }
    };
    fetchPlantId();
  }, [user]);

  // Fetch orders when plantId is available
  React.useEffect(() => {
    if (!plantId) return;
    const fetchOrders = async () => {
      try {
        const response = await getOrdersByProccesingPlantId(user.uid);
        // Log only the relevant part for debugging
        console.log('Orders fetched:', response.data.data);
        setOrders(response.data.data);
      } catch (error) {
        console.error('Error fetching orders:', error);
      }
    };
    fetchOrders();
  }, [plantId]);

  const revenueData = [
    { month: 'Jan', revenue: 3000 },
    { month: 'Feb', revenue: 4000 },
    { month: 'Mar', revenue: 3200 },
    { month: 'Apr', revenue: 4500 },
    { month: 'May', revenue: 5000 },
    { month: 'Jun', revenue: 6000 },
  ];

  const ongoingOrders = [
    { id: 1, product: 'Fish', status: 'Processing', quantity: 10 },
    { id: 2, product: 'Shrimp', status: 'Shipped', quantity: 15 },
    { id: 3, product: 'Crab', status: 'Processing', quantity: 8 },
  ];

  // --- Order statistics ---
  const today = new Date();
  const thisMonth = today.getMonth();
  const thisYear = today.getFullYear();
  const todayStr = today.toISOString().slice(0, 10);
  // Total Orders
  const totalOrders = orders.length;
  // This Month Orders
  const thisMonthOrders = orders.filter((o) => {
    if (!o.Order_Date) return false;
    const d = new Date(o.Order_Date);
    return d.getMonth() === thisMonth && d.getFullYear() === thisYear;
  }).length;
  // Today Orders
  const todayOrders = orders.filter((o) => {
    if (!o.Order_Date) return false;
    return new Date(o.Order_Date).toISOString().slice(0, 10) === todayStr;
  }).length;
  // Paid Orders
  const paidOrders = orders.filter((o) => o.Payment_Status === 'Paid');
  // Pending Orders
  const pendingOrders = orders.filter(
    (o) => o.Status === 'ToPay' || o.Payment_Status === 'ToPay'
  );
  // Rejected Orders (by plant)
  const rejectedOrders = orders.filter(
    (o) => o.Processing_Plant_status === 'false'
  );
  // Accepted Orders (by plant)
  const acceptedOrders = orders.filter(
    (o) => o.Processing_Plant_status === 'true'
  );

  // --- Chart Data ---
  // Monthly Orders Bar Chart
  const monthLabels = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const monthlyOrderCounts = Array(12).fill(0);
  orders.forEach((o) => {
    if (o.Order_Date) {
      const d = new Date(o.Order_Date);
      if (!isNaN(d.getMonth())) monthlyOrderCounts[d.getMonth()]++;
    }
  });
  const monthlyOrdersData = {
    labels: monthLabels,
    datasets: [
      {
        label: 'Orders per Month',
        data: monthlyOrderCounts,
        backgroundColor: '#00A991',
      },
    ],
  };
  // Order Status Doughnut Chart
  const doughnutData = {
    labels: ['Accepted', 'Rejected', 'Pending', 'Paid'],
    datasets: [
      {
        data: [
          acceptedOrders.length,
          rejectedOrders.length,
          pendingOrders.length,
          paidOrders.length,
        ],
        backgroundColor: [
          '#003B8F', // accepted
          '#FF4C4C', // rejected
          '#FFA500', // pending
          '#4CAF50', // paid
        ],
        borderWidth: 1,
      },
    ],
  };
  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { position: 'top' },
      title: { display: true, text: '' },
    },
  };

  // Dynamic today date string
  const days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const day = today.getDate();
  const month = months[today.getMonth()];
  const year = today.getFullYear();
  const weekday = days[today.getDay()];
  const nth = (d) => {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };
  const todayDisplay = `${day}${nth(day)} ${month}, ${year}, ${weekday}`;

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
      <Container
        fluid
        className="mt-4"
      >
        <Row
          className="g-4"
          style={{ minHeight: '100vh' }}
        >
          {/* Left: Stats and Charts */}
          <Col
            lg={12}
            md={12}
            sm={12}
            className="d-flex flex-column gap-4"
          >
            {/* Dashboard Order Stats */}
            <Row
              className="g-4"
              style={{
                background: 'white',
                borderRadius: '10px',
                padding: '24px 12px',
                minHeight: 160,
              }}
            >
              {[
                {
                  title: 'Total Orders',
                  icon: faShoppingCart,
                  value: totalOrders,
                  background: '#00A991',
                },
                {
                  title: 'Accepted Orders',
                  icon: faRocket,
                  value: acceptedOrders.length,
                  background: '#003B8F',
                },
                {
                  title: 'Rejected Orders',
                  icon: faTimesCircle,
                  value: rejectedOrders.length,
                  background: '#FF4C4C',
                },
                {
                  title: 'Pending Orders',
                  icon: faRefresh,
                  value: pendingOrders.length,
                  background: '#FFA500',
                },
                {
                  title: 'Paid Orders',
                  icon: faCreditCard,
                  value: paidOrders.length,
                  background: '#4CAF50',
                },
              ].map(({ title, icon, value, background }, index) => (
                <Col
                  key={index}
                  xs={12}
                  sm={6}
                  md={4}
                  lg={4}
                  xl={4}
                  className="mb-2"
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      background: '#f7fafd',
                      borderRadius: 12,
                      padding: 16,
                      minHeight: 80,
                    }}
                  >
                    <FontAwesomeIcon
                      icon={icon}
                      style={{
                        fontSize: '1.5rem',
                        borderRadius: '40px',
                        background: background,
                        padding: '12px',
                        color: 'white',
                        marginRight: 18,
                      }}
                    />
                    <div>
                      <div
                        className="text-black"
                        style={{ fontWeight: 500 }}
                      >
                        {title}
                      </div>
                      <h3 style={{ margin: 0 }}>{value}</h3>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
            {/* Charts Row */}
            <Row
              className="g-4"
              style={{ minHeight: 320 }}
            >
              <Col
                md={8}
                sm={12}
                className="d-flex flex-column align-items-center justify-content-center"
                style={{
                  background: 'white',
                  borderRadius: '10px',
                  padding: '24px',
                  minHeight: 300,
                }}
              >
                <h6 style={{ marginBottom: 16 }}>Monthly Orders</h6>
                <Bar
                  data={monthlyOrdersData}
                  options={{
                    ...chartOptions,
                    plugins: {
                      ...chartOptions.plugins,
                      title: { display: true, text: 'Orders per Month' },
                    },
                  }}
                />
              </Col>
              <Col
                md={4}
                sm={12}
                className="d-flex flex-column align-items-center justify-content-center"
                style={{
                  background: 'white',
                  borderRadius: '10px',
                  padding: '24px',
                  minHeight: 300,
                }}
              >
                <h6 style={{ marginBottom: 16 }}>Order Status Breakdown</h6>
                <Doughnut
                  data={doughnutData}
                  options={{
                    ...chartOptions,
                    plugins: {
                      ...chartOptions.plugins,
                      title: { display: true, text: 'Order Status' },
                    },
                  }}
                />
              </Col>
            </Row>
          </Col>
          {/* Right: Order Summary */}
          {/* <Col
            lg={4}
            md={12}
            sm={12}
            className="d-flex flex-column align-items-center justify-content-start gap-3"
            style={{
              background: 'white',
              borderRadius: '10px',
              padding: '32px 24px',
              minHeight: 680,
            }}
          >
            <h4 style={{ fontWeight: 600 }}>Order Summary</h4>
            <hr style={{ width: '100%' }} />
            <span
              className="text-black"
              style={{ fontSize: 18 }}
            >
              {todayDisplay}
            </span>
            <hr style={{ width: '100%' }} />
            <span className="text-black">
              This Month Orders <b>{thisMonthOrders} orders</b>
            </span>
            <hr style={{ width: '100%' }} />
            <span className="text-black">
              Today Orders <b>{todayOrders} orders</b>
            </span>
            <img
              src={manChecking}
              alt="Order Checking"
              style={{ paddingTop: '40px', display: 'block', width: '60%' }}
            />
          </Col> */}
        </Row>
        {/* Ongoing Orders Table */}
        <Row className="g-4 mt-4">
          <Col xs={12}>
            <div
              style={{
                backgroundColor: '#fff',
                padding: '28px',
                borderRadius: '10px',
                overflowX: 'auto',
                minHeight: 220,
              }}
            >
              <h5 style={{ fontWeight: 500 }}>Ongoing Orders</h5>
              <DataTable
                columns={columns}
                data={orders}
                pagination
              />
            </div>
          </Col>
        </Row>
      </Container>
    </motion.div>
  );
};

export default Overview;
